interface EventDateTimeFields {
  finalDate?: boolean;
  finalTime?: boolean;
  dateTimeBoundaries?: string;
}

interface DateTimeTooltipTranslations {
  dateAndTimeAreSubjectToChange?: string;
  dateIsSubjectToChange?: string;
  timeIsSubjectToChange?: string;
}

export const getDateTimeBoundariesText = (
  event?: EventDateTimeFields | null
): string | null => {
  const boundaries = event?.dateTimeBoundaries?.trim();
  return boundaries || null;
};

export const getDateNotFinalTooltipText = (
  event: EventDateTimeFields,
  translations: DateTimeTooltipTranslations
): string | null => {
  const boundaries = getDateTimeBoundariesText(event);
  const dateAndTimeNotFinal =
    event.finalDate === false && event.finalTime === false;
  const onlyDateNotFinal =
    event.finalDate === false && event.finalTime === true;
  const onlyTimeNotFinal =
    event.finalDate === true && event.finalTime === false;

  let genericText: string | null = null;
  if (dateAndTimeNotFinal) {
    genericText = translations.dateAndTimeAreSubjectToChange ?? null;
  } else if (onlyDateNotFinal) {
    genericText = translations.dateIsSubjectToChange ?? null;
  } else if (onlyTimeNotFinal) {
    genericText = translations.timeIsSubjectToChange ?? null;
  }

  if (genericText && boundaries) {
    return `${genericText}\n\n${boundaries}`;
  }

  if (boundaries) {
    return boundaries;
  }

  return genericText;
};
